import { IClient, IClients, IUser } from '../services/ApiServiceV1';

export function shouldDenyExternalUserAccess(user: IUser, client: IClients | IClient) {
  return user.isExternal && user.client !== null && user.client.id !== client.id;
}
